import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';
import {
  GET_ALL_ACTIVE_ENUMERATIONS_FAILURE,
  GET_ALL_ACTIVE_ENUMERATIONS_REQUEST,
  GET_ALL_ACTIVE_ENUMERATIONS_SUCCESS,
  GET_ALL_COUNTIRES_REQUEST,
  GET_ALL_COUNTRIES_FAILURE,
  GET_ALL_COUNTRIES_SUCCESS,
  GET_ALL_CURRENCIES_FAILURE,
  GET_ALL_CURRENCIES_REQUEST,
  GET_ALL_CURRENCIES_SUCCESS,
  GET_ALL_ENUMERATIONS_FAILURE,
  GET_ALL_ENUMERATIONS_REQUEST,
  GET_ALL_ENUMERATIONS_SUCCESS,
  GET_ALL_PROVINCES_FAILURE,
  GET_ALL_PROVINCES_REQUEST,
  GET_ALL_PROVINCES_SUCCESS,
  GET_ALL_SALE_TYPES_FAILURE,
  GET_ALL_SALE_TYPES_REQUEST,
  GET_ALL_SALE_TYPES_SUCCESS,
  GET_ALL_WEIGHT_TYPES_FAILURE,
  GET_ALL_WEIGHT_TYPES_REQUEST,
  GET_ALL_WEIGHT_TYPES_SUCCESS,
  GET_CLIENT_POLICY_STATUS_OPTIONS_FAILURE,
  GET_CLIENT_POLICY_STATUS_OPTIONS_REQUEST,
  GET_CLIENT_POLICY_STATUS_OPTIONS_SUCCESS,
  GET_CLIENT_STATUS_OPTIONS_FAILURE,
  GET_CLIENT_STATUS_OPTIONS_REQUEST,
  GET_CLIENT_STATUS_OPTIONS_SUCCESS,
  GET_INDUSTRY_OPTIONS_FAILURE,
  GET_INDUSTRY_OPTIONS_REQUEST,
  GET_INDUSTRY_OPTIONS_SUCCESS
} from './enumeationTypes';

export const getClientStatusOptions = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_STATUS_OPTIONS_REQUEST, GET_CLIENT_STATUS_OPTIONS_SUCCESS, GET_CLIENT_STATUS_OPTIONS_FAILURE],
      authenticated: true,
      endpoint: `api/enumerations/clientStatus`,
      method: 'GET'
    }
  };
};

export const getClientPolicyStatusOptions = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_POLICY_STATUS_OPTIONS_REQUEST, GET_CLIENT_POLICY_STATUS_OPTIONS_SUCCESS, GET_CLIENT_POLICY_STATUS_OPTIONS_FAILURE],
      authenticated: true,
      endpoint: `api/enumerations/clientPolicyStatus`,
      method: 'GET'
    }
  };
};

export const getIndustryOptions = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_INDUSTRY_OPTIONS_REQUEST, GET_INDUSTRY_OPTIONS_SUCCESS, GET_INDUSTRY_OPTIONS_FAILURE],
      authenticated: true,
      endpoint: `api/enumerations/industries`,
      method: 'GET'
    }
  };
};

export const getAllEnumerations = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_ENUMERATIONS_REQUEST, GET_ALL_ENUMERATIONS_SUCCESS, GET_ALL_ENUMERATIONS_FAILURE],
      authenticated: true,
      endpoint: `api/enumerations`,
      method: 'GET'
    }
  };
};

export const getAllActiveEnumerations = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_ACTIVE_ENUMERATIONS_REQUEST, GET_ALL_ACTIVE_ENUMERATIONS_SUCCESS, GET_ALL_ACTIVE_ENUMERATIONS_FAILURE],
      authenticated: true,
      endpoint: `api/enumerations/active`,
      method: 'GET'
    }
  };
};

export const getAllWeightTypes = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_WEIGHT_TYPES_REQUEST, GET_ALL_WEIGHT_TYPES_SUCCESS, GET_ALL_WEIGHT_TYPES_FAILURE],
      authenticated: true,
      endpoint: `api/enumerations/weightTypes`,
      method: 'GET'
    }
  };
};

export const getAllSaleTypes = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_SALE_TYPES_REQUEST, GET_ALL_SALE_TYPES_SUCCESS, GET_ALL_SALE_TYPES_FAILURE],
      authenticated: true,
      endpoint: `api/enumerations/saleTypes`,
      method: 'GET'
    }
  };
};

export const getAllProvinces = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_PROVINCES_REQUEST, GET_ALL_PROVINCES_SUCCESS, GET_ALL_PROVINCES_FAILURE],
      authenticated: true,
      endpoint: `api/enumerations/provinces`,
      method: 'GET'
    }
  };
};

export const getAllCurrencies = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_CURRENCIES_REQUEST, GET_ALL_CURRENCIES_SUCCESS, GET_ALL_CURRENCIES_FAILURE],
      authenticated: true,
      endpoint: `api/enumerations/currencies`,
      method: 'GET'
    }
  };
};

export const getAllCountries = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_COUNTIRES_REQUEST, GET_ALL_COUNTRIES_SUCCESS, GET_ALL_COUNTRIES_FAILURE],
      authenticated: true,
      endpoint: `api/enumerations/countries`,
      method: 'GET'
    }
  };
};
